export { default as useProcessAttachment } from "./useProcessAttachment";
